import { useState, useEffect, useCallback, useRef } from "react";
import styles from "./App.module.scss";

const AddFiles = () => {
  const [modalShow, setModalShow] = useState(false);
  const [count, setCount] = useState(0);
  const dropArea = useRef();
  const file1 = useRef();
  const file2 = useRef();
  const file3 = useRef();
  const file4 = useRef();
  const file5 = useRef();
  const refs = [file1, file2, file3, file4, file5];

  // ドラッグ&ドロップ
  const fileDragOver = (e) => {
    e.stopPropagation();
    e.preventDefault();
    e.currentTarget.style.background = "#d9e8ff";
  };
  const fileDragLeave = (e) => {
    e.stopPropagation();
    e.preventDefault();
    e.currentTarget.style.background = "";
  };
  const fileDrop = (e) => {
    e.stopPropagation();
    e.preventDefault();
    e.currentTarget.style.background = "";
    let files = e.dataTransfer.files;
    dropArea.current.files = files;
    multiInput();
  };

  // ファイル仕分け
  const multiInput = () => {
    const files = Array.from(dropArea.current.files);
    files.map((file, i) => {
      if (file.type === "application/pdf") {
        const dt = new DataTransfer();
        dt.items.add(file);
        if (file1.current.value === "") {
          file1.current.type = "file";
          file1.current.files = dt.files;
          file1.current.previousElementSibling.textContent = file.name;
        } else if (file2.current.value === "") {
          file2.current.type = "file";
          file2.current.files = dt.files;
          file2.current.previousElementSibling.textContent = file.name;
        } else if (file3.current.value === "") {
          file3.current.type = "file";
          file3.current.files = dt.files;
          file3.current.previousElementSibling.textContent = file.name;
        } else if (file4.current.value === "") {
          file4.current.type = "file";
          file4.current.files = dt.files;
          file4.current.previousElementSibling.textContent = file.name;
        } else if (file5.current.value === "") {
          file5.current.type = "file";
          file5.current.files = dt.files;
          file5.current.previousElementSibling.textContent = file.name;
        } else {
          window.alert("添付ファイルは5つまでです。");
        }
      } else if (file.type.includes("image")) {
        let inputImg = file;
        let inputImgUrl = window.URL.createObjectURL(inputImg);
        let imgElm = new Image();
        imgElm.src = inputImgUrl;
        imgElm.addEventListener("load", () => {
          let postImg = compress(imgElm);
          if (file1.current.value === "") {
            file1.current.type = "hidden";
            file1.current.value = postImg;
            file1.current.previousElementSibling.textContent = file.name;
          } else if (file2.current.value === "") {
            file2.current.type = "hidden";
            file2.current.value = postImg;
            file2.current.previousElementSibling.textContent = file.name;
          } else if (file3.current.value === "") {
            file3.current.type = "hidden";
            file3.current.value = postImg;
            file3.current.previousElementSibling.textContent = file.name;
          } else if (file4.current.value === "") {
            file4.current.type = "hidden";
            file4.current.value = postImg;
            file4.current.previousElementSibling.textContent = file.name;
          } else if (file5.current.value === "") {
            file5.current.type = "hidden";
            file5.current.value = postImg;
            file5.current.previousElementSibling.textContent = file.name;
          } else {
            window.alert("添付ファイルは5つまでです。");
          }
        });
      } else {
        window.alert("画像、PDF以外の添付はできません。");
      }
    });
    dropArea.current.value = "";
  };

  //画像圧縮処理
  const compress = useCallback((largeImg) => {
    let mime_type = "image/jpeg";
    let maxWidth = 1980;
    let natW = largeImg.naturalWidth;
    let natH = largeImg.naturalHeight;
    let ratio = natH / natW;
    if (natW > maxWidth) {
      natW = maxWidth;
      natH = ratio * maxWidth;
    }
    let cvs = document.createElement("canvas");
    cvs.width = natW;
    cvs.height = natH;
    let ctx = cvs.getContext("2d");
    ctx.drawImage(largeImg, 0, 0, natW, natH);
    let newImageData = cvs.toDataURL(mime_type, 90 / 100);
    return newImageData;
  });

  // 添付数カウント
  useEffect(() => {
    let fileSum = refs.reduce(
      (sum, ref) =>
        ref.current.previousElementSibling.textContent === "未選択"
          ? sum
          : sum + 1,
      0
    );
    setCount(() => fileSum);
  }, [modalShow]);

  return (
    <>
      <a className={styles.addImgBtn} onClick={() => setModalShow(true)}>
        {count > 0 ? <>{count}ファイル選択中</> : <>画像・PDFを添付する</>}
      </a>
      <div
        className={styles.modal}
        style={
          modalShow
            ? { opacity: 1, visibility: "visible" }
            : { opacity: 0, visibility: "hidden" }
        }
      >
        <span onClick={() => setModalShow(false)}></span>
        <div
          style={
            modalShow
              ? { transform: "translate(-50%,-50%)" }
              : { transform: "translate(-50%,-20%)" }
          }
        >
          <h3 className={styles.headline}>
            FILE<span>画像・PDFを5枚まで添付できます</span>
          </h3>

          <label
            onDragOver={fileDragOver}
            onDragLeave={fileDragLeave}
            onDrop={fileDrop}
          >
            <img src="images/up_load.png" alt="" />
            <p>
              <span className="sp">
                ファイルをアップロードする
                <br />
              </span>
              <span className="pc">
                ここにファイルをドラッグ&ドロップ
                <br />
                <small>または</small>
                <br />
              </span>
            </p>
            <a>ファイルを選択</a>

            <input
              ref={dropArea}
              type="file"
              onChange={multiInput}
              accept="image/*,.pdf"
              multiple
            />
          </label>

          <ul>
            <li>
              <span
                onClick={() => {
                  file1.current.value = "";
                  file1.current.previousElementSibling.textContent = "未選択";
                }}
              ></span>
              <p>未選択</p>
              <input name="file1" type="hidden" ref={file1} />
            </li>
            <li>
              <span
                onClick={() => {
                  file2.current.value = "";
                  file2.current.previousElementSibling.textContent = "未選択";
                }}
              ></span>
              <p>未選択</p>
              <input name="file2" type="hidden" ref={file2} />
            </li>
            <li>
              <span
                onClick={() => {
                  file3.current.value = "";
                  file3.current.previousElementSibling.textContent = "未選択";
                }}
              ></span>
              <p>未選択</p>
              <input name="file3" type="hidden" ref={file3} />
            </li>
            <li>
              <span
                onClick={() => {
                  file4.current.value = "";
                  file4.current.previousElementSibling.textContent = "未選択";
                }}
              ></span>
              <p>未選択</p>
              <input name="file4" type="hidden" ref={file4} />
            </li>
            <li>
              <span
                onClick={() => {
                  file5.current.value = "";
                  file5.current.previousElementSibling.textContent = "未選択";
                }}
              ></span>
              <p>未選択</p>
              <input name="file5" type="hidden" ref={file5} />
            </li>
          </ul>
          <a onClick={() => setModalShow(false)}>閉じる</a>
        </div>
      </div>
    </>
  );
};

export default AddFiles;
